import PropTypes from 'prop-types';
import React from 'react';
import { CAN_SUBMIT } from '../../../../contexts/JobReviewContext';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';

import ButtonCard from '../../QuestionCards/ButtonCard/ButtonCard';

export default class Salary extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            salary: this.props.salary || null,
            isPublic: this.props.isPublic,
        };
    }
    static propTypes = {
        onAnswer: PropTypes.func,
        buttonType: PropTypes.string,
        buttonData: PropTypes.array,
        showCheckbox: PropTypes.bool,
        checkboxLabel: PropTypes.string,
    };
    static defaultProps = {
        buttonType: 'single',
        buttonData: [
            {
                title: '0 - $25k',
                value: '0-25k',
            },
            {
                title: '$25k - $50k',
                value: '25k-50k',
            },
            {
                title: '$50k - $80k',
                value: '50k-80k',
            },
            {
                title: '$80k - $100k',
                value: '80k-100k',
            },
            {
                title: '$100k - $150k',
                value: '100k-150k',
            },
            {
                title: '$150k+',
                value: '>150k',
            },
        ],
        isPublic: true,
        showCheckbox: true,
        checkboxLabel: 'Please do not publish this information.',
        onAnswer: () => {},
    };

    handleUpdate = (selectedValues) => {
        // only 1 selection is possible, so use first result or null if undefined
        const answer = {
            salary: selectedValues[0] || null,
            isPublic: this.state.isPublic,
        };
        this.setState({ salary: answer.salary });
        this.submitAnswer(answer);
    };

    handleCheckBox = (isChecked) => {
        const answer = {
            isPublic: !isChecked,
            salary: this.state.salary,
        };
        this.setState({ isPublic: answer.isPublic });
        this.submitAnswer(answer);
    };

    submitAnswer = (answer) => {
        const salaryAnswer = answer.salary
            ? answer
            : { salary: null, isPublic: true };

        this.props.onAnswer(
            'salary',
            salaryAnswer,
            CAN_SUBMIT,
            false,
            this.props.nextStep
        );
    };

    componentDidMount() {
        EmitMetric({
            misc_event_type: 'job-review-question-started-demographic-1',
            misc_event_count: 1,
        });
        const answer = this.props.salary
            ? {
                  salary: this.props.salary,
                  isPublic: !!this.props.isPublic,
              }
            : null;
        this.props.salary
            ? this.props.onAnswer(
                  'salary',
                  answer,
                  CAN_SUBMIT,
                  false,
                  this.props.nextStep
              )
            : null;
    }

    render() {
        return (
            <ButtonCard
                {...this.props}
                onClick={this.handleUpdate}
                handleCheckBox={this.handleCheckBox}
                selectedItems={this.props.salary}
                hasSubtitle={true}
                isChecked={!this.props.isPublic}
            />
        );
    }
}
